module.exports = __webpack_public_path__ + "videos/pencil-filters_cn.fa44408.mp4";